import { MDCSlider } from '@material/slider';
import template      from './defa-slider.vue.html';

export const DefaSliderComponent = {
	template,
	props: {
		min  : {
			type   : Number,
			default: 0
		},
		max  : {
			type   : Number,
			default: 10
		},
		value: {
			type   : Number,
			default: 0
		},
		label: {
			type: String,
			default: 'Select value'
		}
	},
	mounted() {
		const slider = new MDCSlider( this.$el );
		slider.listen( 'MDCSlider:change', () => {
			this.$emit( 'input', slider.value );
		} );
	}
};


export const SliderPlugin = {
	install( Vue, options ) {
		Vue.component( 'defa-slider', DefaSliderComponent );
	}
};